<template>
  <vue-tel-input
    ref="input"
    :value="value"
    :disabled="disabled"
    inputId="recipients_phone"
    @input="input"
    @enter="enter"
    @blur="blur"
  />
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      },

      /**
       * Имеет модификатор .sync (Двустороння привязка)
       * Содержит всевозможную инфу о номере
       * Например:
       * {
       *  "number": {
       *     "input": "+7 999 222-33-22",
       *     "international": "+7 999 222-33-22",
       *     "national": "8 (999) 222-33-22",
       *     "e164": "+79992223322",
       *     "rfc3966": "tel:+7-999-222-33-22",
       *     "significant": "9992223322"
       *   },
       *   "regionCode": "RU",
       *   "valid": true,
       *   "possible": true,
       *   "canBeInternationallyDialled": true,
       *   "type": "mobile",
       *   "possibility": "is-possible",
       *   "isValid": true,
       *   "country": {
       *     "name": "Russia (Россия)",
       *     "iso2": "RU",
       *     "dialCode": "7",
       *     "priority": 0,
       *     "areaCodes": null
       *    }
       *   }
       **/

      phone_object: {
        type: Object,
        default: () => ({})
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      focus() {
        this.$refs.input.focus();
      },

      enter: function() {
        return this.$emit('enter');
      },

      blur: function() {
        return this.$emit('blur');
      },

      input: function(format, obj) {
        const updatedObj = { ...obj };
        const { number } = updatedObj;

        const isRuCode = obj.country.iso2 === 'RU';
        const checkPrefix = number.input == 7 || number.input == 8;
        const inputField = number.input.toString();

        if (checkPrefix) {
          number.input = '+7';
        } else if (isRuCode && inputField.length === 10 && !inputField.includes('+')) {
          number.input = `+7${number.input}`;
        }

        this.$emit('update:phone_object', updatedObj);
        this.$emit('on-input', updatedObj);
        return this.$emit('input', number.input);
      }
    }
  };
</script>
